import Script from 'next/script';
import { PrizePage } from '@thisisdevelopment/heritage-core-library';
import Head from 'next/head';
import Link from 'next/link';
import { Paragraph, config } from '@thisisdevelopment/akzonobel-core';

export default function Newsletter() {
  return (
    <>
      <Head>
        <title>Dulux Heritage Prize Draw</title>
      </Head>
      <PrizePage
        title="Dulux Heritage Competition"
        content={
          <>
            <Paragraph>Thank you for entering.</Paragraph>
            <Paragraph>
              If you have subscribed to our email newsletter, make sure you check your inbox for our
              confirmation email in the next few days. Find out more about Dulux Heritage Trade{' '}
              <Link href="/en/for-professionals">here</Link>.
            </Paragraph>
          </>
        }
        image={{
          url: `https://datahose-cms.akzonobel.hosting/${config.domainCode}/assets/1mrtdtue8zesgwsc`,
          alt: 'Dulux Heritage Competition',
        }}
      >
        <div style={{ height: '120px' }} />
        <Script id="fb-pixel" strategy="afterInteractive">
          {`
            !function(f,b,e,v,n,t,s) {
              if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1632094923699192');
            fbq('track', 'PageView');
          `}
        </Script>
      </PrizePage>
    </>
  );
}
